import React, { FC, useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { ControllerProps } from 'react-hook-form/dist/types/controller';

type IProps = Omit<ControllerProps, 'render'>;

export const HiddenInputController: FC<IProps> = ({ name, ...restProps }) => {
  const renderFn = useCallback<ControllerProps['render']>(({ field }) => <input {...field} type="hidden" />, []);

  return <Controller name={name} render={renderFn} {...restProps} />;
};
